import { DEFAULT_TERMS, type Term, type TermKey, type Workspace } from '@/types/workspace'

/** The company's word, or the product default while no session (or a stale one) says otherwise. */
export function resolveTerm(workspace: Workspace | null | undefined, key: TermKey): Term {
  return workspace?.terms?.[key] ?? DEFAULT_TERMS[key]
}
